<template>
  <div class="person-index">
    <!-- 头部导航 -->
    <div id="header">
      <div class="header content-continer">
        <p class="logo left">
          <router-link to="/home">
            <img src="../assets/logo.png" />
          </router-link>
        </p>
        <!-- <p class="right icon-btn" @click="returns">
          <img src="../assets/hospital-img/return.png" />退出
        </p> -->
        <p class="right icon-btn">
          <img
            :src="imgurl+personlist.workImgUrl"
            style="width:40px;height:40px;border-radius:40px;"
          />

          <el-dropdown trigger="click">
            <span>{{personlist.cnName}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-popover
                  placement="right"
                  trigger="hover"
                  width="100"
                >
                  <span slot="reference">角色切换</span>
                  <slot name="content">
                    <p class="header-role" @click="switchRole(2)">机构账号</p>
                    <p class="header-role" @click="switchRole(1)">公司账号</p>
                  </slot>

                  <!-- 1公司 2机构（医院）  3个人(crc)-->
                </el-popover>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="returns">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          
        </p>
      </div>
    </div>
    <!-- 添加简历 -->
    <div class="content-continer peview peview-add">
      <ul style="margin-top:50px;margin-bottom: 100px;">
        <li>
          <div class="left peview-img"> 
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload"
              name="fileName"
            >
              <img
                v-if="personlist.workImgUrl"
                :src="imgurl+personlist.workImgUrl"
                class="avatar"
                style="height:120px;width:auto;"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="left">
            
            <p class="peview-name" style="padding-top:10px;">{{personlist.cnName}} </p>
            <p class="peview-xq">
              <span>
                <img src="../assets/phone.png" />
                {{personlist.mobile}}
              </span>
              <span>
                <img src="../assets/old.png" />
                {{personlist.age}}岁
              </span>
              <span>
                <img src="../assets/address.png" />
                {{personlist.city}}
              </span>
            </p>
          </div>
          <!-- <div class="right" style="margin-top:60px;"> -->
          <div class="right" style="margin-top:30px;">
            <!-- <el-button type="text" @click="dialogVisible = true">
              <i class="el-icon-edit-outline sed-title"></i>编辑
            </el-button>-->
            <div @click="previewMsg(userid)" style="cursor: pointer;">
              <img src="../assets/yulan.png" />
              <p style="text-align: center; color:#4A88D3; font-size: 12px; font-weight: bold;padding-top: 10px;">预览</p>
            </div>
          </div>
          <div style="clear:both"></div>
        </li>
        <!-- 教育经历************************************************************************ -->
        <li>
          <div class="peview-list-title">
            <span>教育经历</span>
            <span class="preview-list-must">必填</span>
            <p class="buit-btn right" @click="editedu(1)">
              <img src="../assets/hospital-img/add.png" />添加
            </p>
          </div>

          <ul>
            <li v-for="(item,index) in personlist.eduList">
              <div class="peview-list-title-name">{{item.schoolName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}/{{item.endDate}}</span>|
                <span>{{item.eduLevelDesc}}</span>|
                <span v-if="item.isGeneral==1">统招</span>
                <span v-if="item.isGeneral==0">自考</span>|
                <span>{{item.majorName}}</span>
              </div>
              <p class="right edit-person">
                <el-button
                  type="text"
                  @click="editedu(2,item.schoolName,item.startDate,{dictId:item.eduLevel,dictValue:item.eduLevelDesc},item.endDate,item.isGeneral,item.majorName,item.id)"
                >
                  <i class="el-icon-edit-outline sed-title"></i>编辑
                </el-button>
              </p>
            </li>
          </ul>
          <ul v-if="personlist.eduList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
        <!-- 培训经历***************************************************************************** -->
        <li>
          <div class="peview-list-title">
            培训经历
            <p class="buit-btn right" @click="edittrain(1)">
              <img src="../assets/hospital-img/add.png" />添加
            </p>
          </div>
          <ul>
            <li v-for="(item,index) in personlist.trainList">
              <div class="peview-list-title-name">{{item.schoolName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}/{{item.endDate}}</span>|
                <span>{{item.courseName}}</span>
              </div>
              <p class="right edit-person">
                <el-button
                  type="text"
                  @click="edittrain(2,item.schoolName,item.startDate,item.endDate,item.courseName,item.id)"
                >
                  <i class="el-icon-edit-outline sed-title"></i>编辑
                </el-button>
              </p>
            </li>
          </ul>
          <ul v-if="personlist.trainList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
        <!-- 获得证书************************************************************************************* -->
        <li>
          <div class="peview-list-title">
            获得证书
            <p class="buit-btn right" @click="editcertificate(1)">
              <img src="../assets/hospital-img/add.png" />添加
            </p>
          </div>
          <ul>
            <li v-for="(item,index) in personlist.certificateList" :key="index">
              <div class="peview-list-title-name">{{item.certificateName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.getTime}}</span>|
                <span>{{item.certificateName}}</span>
                <!-- <span>{{item.id}}</span> -->
              </div>
              <p class="right edit-person">
                <el-button
                  type="text"
                  @click="editcertificate(2,item.certificateName,item.getTime,item.imgUrl,item.id)"
                >
                  <i class="el-icon-edit-outline sed-title"></i>编辑
                </el-button>
              </p>
            </li>
          </ul>
          <ul v-if="personlist.certificateList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
        <!-- 项目经历******************************************************************************************* -->
        <li>
          <div class="peview-list-title">
            <span>项目经历(个人备案）</span>
            <span class="preview-list-must">必填</span>
            <p class="buit-btn right" @click="editExperiences(1)">
              <img src="../assets/hospital-img/add.png" />添加
            </p>
          </div>
          <ul>
            <img src="../assets/geren-icon1.png" class="peview-b-icon" />
            <li v-for="(item,index) in personlist.projectExpList0" :key="index">
              <div class="peview-list-title-name">{{item.projectName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}} / {{item.endDate?item.endDate:'至今'}}</span>|
                <span>{{item.specialtyName}}</span>|
                <span>{{item.hospitalName}}</span>
                <p class="right edit-person">
                  <el-button
                    type="text"
                    @click="editExperiences(2,item.projectName,item.smoName,item.phase,item.phaseDesc,{specId:item.specialtyId,specName:item.specialtyName},item.startDate,item.endDate,item.managerName,item.managerMobile,item.workDesc,item.id)"
                  >
                    <i class="el-icon-edit-outline sed-title"></i>编辑
                  </el-button>
                </p>
              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item.smoName?item.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>证明人</p>
                  <p>{{item.managerName?item.managerName:'无'}}</p>
                </li>
                <li>
                  <p>证明人电话</p>
                  <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
                </li>
                <li style="display:block;" v-if="item.workDesc">
                  <p>项目描述及个人职责:</p>
                  <p>{{item.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
          <ul v-if="personlist.projectExpList0==''">
            <li>暂无数据</li>
          </ul>
        </li>
        <li>
          <div class="peview-list-title">项目经历(公司备案)</div>
          <img src="../assets/geren-icon2.png" class="peview-b-icon"/>
          
          <ul>
            <li v-for="(item, index) in personlist.projectExpList1" :key="index">
              <img src="../assets/chapter.png" style="position: absolute;right: 110px;" v-if="personlist.projectExpList1 != ''"/>
              <div class="peview-list-title-name">
                {{item.projectName}}
                <span v-if="item.projectState=='2'" class="projectState">进行中</span>
              </div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}} / {{item.endDate?item.endDate:'至今'}}</span>|
                <span>{{item.specialtyName}}</span>|
                <span>{{item.hospitalName}}</span>
              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item.smoName?item.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>负责人</p>
                  <p>{{item.managerName?item.managerName:'无'}}</p>
                </li>
                <li>
                  <p>负责人电话</p>
                  <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
                </li>
                <li style="display:block;" v-if="item.workDesc">
                  <p>项目描述及个人职责:</p>
                  <p>{{item.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
          <ul v-if="personlist.projectExpList1==''">
            <li>暂无数据</li>
          </ul>
          <div style="clear: both"></div>
        </li>
      </ul>
    </div>
    <!-- 编辑个人信息 -->

    <el-dialog title="个人基本信息" :visible.sync="dialogVisible" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>姓名</span>
          <input type="text" placeholder="输入姓名" />
        </p>
        <p>
          <span>电话</span>
          <input type="text" placeholder="输入手机号" />
        </p>
        <p>
          <span>年龄</span>
          <input type="text" placeholder="输入年龄" />
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加和编辑教育信息 -->
    <el-dialog title="教育经历" :visible.sync="dialogVisible2" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>学校</span>
          <input type="text" placeholder="输入学校" v-model="schoolName" />
        </p>
        <p>
          <span>专业</span>
          <input type="text" placeholder="输入专业" v-model="majorName" />
        </p>
        <p>
          <span>入学日期</span>
          <el-date-picker v-model="start1" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </p>
        <p>
          <span>毕业时间</span>
          <el-date-picker v-model="end1" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </p>
        <p>
          <span>学历</span>
          <el-select v-model="edu" placeholder="请选择" value-key="dictId">
            <el-option
              v-for="item in edulist"
              :key="item.dictId"
              :label="item.dictValue"
              :value="item"
            ></el-option>
          </el-select>
        </p>
        <p>
          <span>是否统招</span>
          <el-select v-model="isGeneral" placeholder="请选择" clearable>
            <el-option
              v-for="item in isGeneraloptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="addEdu()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加和编辑培训经历 -->

    <el-dialog title="培训经历" :visible.sync="dialogVisible3" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>培训机构</span>
          <input type="text" placeholder="输入培训机构" v-model="schoolName2" />
        </p>
        <p>
          <span>课程</span>
          <input type="text" placeholder="输入课程" v-model="courseName" />
        </p>
        <p>
          <span>开始日期</span>
          <el-date-picker v-model="startDate2" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </p>
        <p>
          <span>结束时间</span>
          <el-date-picker
            v-model="endDate2"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="addTrain()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加和编辑证书 -->

    <el-dialog title="证书" :visible.sync="dialogVisible4" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>证书名称</span>
          <input type="text" placeholder="输入证书名称" v-model="certificateName" />
        </p>
        <p>
          <span>获得日期</span>
          <el-date-picker v-model="getTime" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </p>
        <p>
          <span>上传证书</span>
          <el-upload
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            name="fileName"
          >
            <img v-if="imageUrl" :src="imgurl+imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="getcertificate()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加和项目经历 -->
    <el-dialog title="项目经历" :visible.sync="dialogVisible5" width="830px" center>
      <form class="forms grid-content xm">
        <el-row :gutter="20">
          <el-col :span="12">
            <p>
              <span>项目名称</span>
              <input type="text" placeholder="输入项目名称" v-model="projectName" />
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span>公司名称</span>
              <input type="text" placeholder="输入公司名称" v-model="smoName" />
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span>项目类型</span>
              <el-select v-model="phase" placeholder="请选择" value-key="value">
                <el-option
                  v-for="item in phaselist"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </p>
          </el-col>
          <el-col :span="24">
            <p>
              <span>专业名称</span>
              <el-select v-model="specialtyvalue" placeholder="请选择专业名称" @change="specialchange">
                <el-option
                  v-for="item in specialtylist"
                  :key="item.specId"
                  :label="item.specName"
                  :value="item.specId"
                ></el-option>
              </el-select>
              <el-select v-model="speciality" placeholder="请选择专业名称" value-key="specId">
                <el-option
                  v-for="item in specialty2"
                  :key="item.specId"
                  :label="item.specName"
                  :value="item"
                ></el-option>
              </el-select>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span>项目开始时间</span>
              <el-date-picker v-model="startDate3" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span>项目结束时间</span>
              <el-date-picker v-model="endDate3" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span>证明人</span>
              <input type="text" placeholder="输入证明人" v-model="managerName" />
            </p>
          </el-col>

          <el-col :span="12">
            <p>
              <span>证明人手机号</span>
              <input type="text" placeholder="输入证明人手机号" v-model="managerMobile" />
            </p>
          </el-col>

          <el-col :span="24">
            <p>
              <span class="miaoshu">项目描述及个人职责</span>
              <!-- <input type="text" placeholder="请输入项目描述及个人职责" v-model="workDesc" style="width:620px;" /> -->
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入项目描述及个人职责"
                v-model="workDesc"
                style="width:620px;"
              ></textarea>
            </p>
          </el-col>
        </el-row>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="projectExperiences()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看详情弹出框 -->
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getpersoninfo } from "@/request/api";
import { getEdu } from "@/request/api";
import { addEdu } from "@/request/api";
import { editEdu } from "@/request/api";

import { addTrain } from "@/request/api";
import { editTrain } from "@/request/api";

import { getcertificate } from "@/request/api";
import { editcertificate } from "@/request/api";

import { getSpecialty } from "@/request/api";
import { projectExperiences } from "@/request/api";
import { editExperiences } from "@/request/api";
import { editWorkimg } from "@/request/api";

import Preview from "@/person/preview";
import { switchRole } from "@/request/api";

export default {
  components: {
    Preview: Preview
  },
  data() {
    return {
      action: this.Common.serverSrc,
      peviewstatus: false,
      status: "",
      dialogVisible: false,
      peviewstatus: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      userid: "",
      personlist: "",
      start1: "", //入学时间
      end1: "", //毕业时间
      edulist: "", //学历列表
      edu: "", //学历选中项
      isGeneraloptions: [
        {
          value: "0",
          label: "否"
        },
        {
          value: "1",
          label: "是"
        }
      ],
      isGeneral: "1", //是否统招
      schoolName: "",
      majorName: "", //添加专业
      schoolName2: "", //添加培训学校
      courseName: "", //添加培训课程
      startDate2: "", //培训开始时间
      endDate2: "", //培训结束时间
      getTime: "", //获得证书日期
      certificateName: "", //证书名称
      imageUrl: "", //证书图片
      imgurl: this.Common.imgurl,
      // 新增项目经历
      phaselist: [
        {
          value: "1",
          label: "Ⅰ期"
        },
        {
          value: "2",
          label: "Ⅱ期"
        },
        {
          value: "3",
          label: "Ⅲ期"
        },
        {
          value: "4",
          label: " Ⅳ期"
        }
      ],
      specialtylist: [], //专业一级菜单
      specialty2: [], //专业二级菜单
      specialtyvalue: "", //专业一级选中项
      speciality: {}, //专业二级菜单选中项
      phase: "", //项目类型id和name
      projectName: "", //项目名称
      smoName: "", //公司名称
      startDate3: "", //项目开始时间
      endDate3: "", //项目结束时间
      managerName: "", //证明人
      managerMobile: "", //证明人电话
      workDesc: "", //项目描述
      // 编辑的id
      id: "",
      childid: "",
      workImgUrl: ""
    };
  },
  methods: {

    // 切换登陆的角色类型
    switchRole:async function(param){
      try{
        let responseData = await switchRole(param);
        if(responseData.data.code == '00000'){
          // 清除-退出
          Cookies.remove("token");
          Cookies.remove("userid");
          Cookies.remove("unionId");
          Cookies.remove("orgName");
          // 再次登陆
          this.logining(responseData.data.data);
        }else{
          this.$message.error(responseData.data.message);
        }
      }catch(error){
        console.log(error);
      }
    },

    logining(param) {
     
      Cookies.set("token", param.token);
      Cookies.set("userid", param.userId);
      Cookies.set("accountType", param.accountType);
      Cookies.set("orgName", param.orgName);

      this.$message({
        message: "账号切换成功",
        type: "success"
      });

      // 进入首页
      if(param.accountType == 1){
        this.$router.replace("/CIndex/company-home");
      }else if(param.accountType == 2){
        this.$router.replace("/HIndex/hostipal-home");
      }else if(param.accountType == 3){
        this.$router.push('/person-home')
      }
    },


    handleAvatarSuccess(res, file) {
      this.imageUrl = res.fileName;
      console.log(res.fileName);
    },
    handleAvatarSuccess1(res, file) {
      this.workImgUrl = res.fileName;
      console.log(res.fileName);
      let data = {
        imgPath: this.workImgUrl,
        userId: this.userid
      };
      editWorkimg(data)
        .then(res => {
          this.$message({
            message: res.data.message,
            type: "success"
          });
          this.getlist();
        })
        .catch(err => {});
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    previewMsg(crcId) {
      this.childid = crcId;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    closePeview() {
      this.peviewstatus = false;
    },

    //信息
    getlist() {
      getpersoninfo(this.userid)
        .then(res => {
          this.personlist = res.data.data;
          console.log("CRC终极测试dabug~this.personlist", this.personlist);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 编辑教育经历弹框
    editedu(status, schoolName, start, edu, end, isGengeral, majorname, id) {
      this.dialogVisible2 = true;
      if (status == "2") {
        this.status = "edit";
      } else {
        this.status = "add";
      }
      this.edu = edu;
      this.end1 = end;
      if (isGengeral == 0) {
        this.isGeneral = "0";
      } else {
        this.isGeneral = "1";
      }
      this.majorName = majorname;
      this.schoolName = schoolName;
      this.start1 = start;
      this.id = id;
    },

    // 教育经历部分的相关验证处理

    // （0）去除字符串空格处理
    removeAllSpace(str) {
      return str.replace(/\s+/g, "");
    },

    // （1）学校的验证
    eduSchoolCheck() {
      if (this.schoolName) {
        // 不能纯数字
        // 不能纯特殊字符
        let tempProjectDesc = this.removeAllSpace(this.schoolName);
        // 纯数字的验证(整数或者小数)
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        // 纯特殊字符
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/;
        if (
          myregNum.test(this.tempProjectDesc) ||
          myregParti.test(this.tempProjectDesc)
        ) {
          this.$message.error("学校名称请勿输入纯数字或者纯特殊字符");
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("请输入学校名称");
        return false;
      }
    },

    //（2）专业的验证
    eduProCheck() {
      if (this.majorName) {
        // 不能纯数字
        // 不能纯特殊字符
        let tempProjectDesc = this.removeAllSpace(this.majorName);
        // 纯数字的验证(整数或者小数)
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        // 纯特殊字符
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/;
        if (
          myregNum.test(tempProjectDesc) ||
          myregParti.test(tempProjectDesc)
        ) {
          this.$message.error("专业名称请勿输入纯数字或者纯特殊字符");
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("请输入专业名称");
        return false;
      }
    },

    //（3）入学日期的验证
    eduEnterCheck() {
      console.log("测试入学时间的类型", typeof this.start1);
      if (this.start1) {
        if (this.end1) {
          // 进行数据比对
          let tempDateStart = new Date(this.start1);
          let tempDateEnd = new Date(this.end1);
          let tempStampStart = tempDateStart.getTime();
          let tempStampEnd = tempDateEnd.getTime();

          if (tempStampEnd > tempStampStart) {
            return true;
          } else {
            this.$message.error("毕业时间应该大于入学时间，请重新选择");
            return false;
          }
        } else {
          return true;
        }
      } else {
        this.$message.error("请选择入学时间");
        return false;
      }
    },

    //（4）毕业时间的验证
    eduLeaveCheck() {
      if (this.end1) {
        if (this.star1) {
          // 进行数据比对

          let tempDateStart = new Date(this.start1);
          let tempDateEnd = new Date(this.end1);
          let tempStampStart = tempDateStart.getTime();
          let tempStampEnd = tempDateEnd.getTime();

          if (tempStampEnd > tempStampStart) {
            return true;
          } else {
            this.$message.error("毕业时间应该大于入学时间，请重新选择");
            return false;
          }
        } else {
          return true;
        }
      } else {
        this.$message.error("请选择毕业时间");
        return false;
      }
    },

    //（5）学历的验证
    eduDegreeCheck() {
      if (this.edu) {
        return true;
      } else {
        this.$message.error("请选择学历");
        return false;
      }
    },

    //（6）是否统招的验证
    eduIsCheck() {
      if (this.isGeneral) {
        return true;
      } else {
        this.$message.error("请选择是否是统招");
        return false;
      }
    },

    //添加和修改教育经历
    addEdu() {
      if (
        !(
          this.eduSchoolCheck() &&
          this.eduProCheck() &&
          this.eduEnterCheck() &&
          this.eduLeaveCheck() &&
          this.eduDegreeCheck() &&
          this.eduIsCheck()
        )
      ) {
        console.log("验证失败，不通过");
      } else {
        if (this.status == "add") {
          let data = {
            crcId: this.userid, //userid
            eduLevel: this.edu.dictId,
            eduLevelDesc: this.edu.dictValue,
            endDate: this.end1,
            isGeneral: this.isGeneral,
            majorName: this.majorName,
            schoolName: this.schoolName,
            startDate: this.start1
          };

          addEdu(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible2 = false;
            })
            .catch(err => {});
        } else if (this.status == "edit") {
          // alert(this.edu.dictValue);
          let data = {
            id: this.id, //userid
            eduLevel: this.edu.dictId,
            eduLevelDesc: this.edu.dictValue,
            endDate: this.end1,
            isGeneral: this.isGeneral,
            majorName: this.majorName,
            schoolName: this.schoolName,
            startDate: this.start1
          };
          editEdu(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible2 = false;
            })
            .catch(err => {});
        }
      }
    },
    // 编辑培训经历弹框
    edittrain(status, schoolName, startDate, endDate, courseName, id) {
      this.dialogVisible3 = true;
      if (status == "2") {
        this.status = "edit";
      } else {
        this.status = "add";
      }
      this.schoolName2 = schoolName;
      this.startDate2 = startDate;
      this.endDate2 = endDate;
      this.courseName = courseName;
      this.id = id;
    },
    //添加培训经历

    // 培训机构名称验证处理（1）
    mechanNameCheck() {
      if (this.schoolName2) {
        // 纯的判断
        let tempProjectDesc = this.removeAllSpace(this.schoolName2);
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/;
        if (
          myregNum.test(tempProjectDesc) ||
          myregParti.test(tempProjectDesc)
        ) {
          this.$message.error("机构名称不合法,请勿输入纯数字或者纯特殊字符");
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("请输入培训机构的名称");
        return false;
      }
    },

    // 课程验证处理 （2）
    mechanClassCheck() {
      if (this.courseName) {
        // 纯的判断
        let tempProjectDesc = this.removeAllSpace(this.courseName);
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/;
        if (
          myregNum.test(tempProjectDesc) ||
          myregParti.test(tempProjectDesc)
        ) {
          this.$message.error("课程名称不合法,请勿输入纯数字或者纯特殊字符");
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("请输入课程名称");
        return false;
      }
    },

    // 开始验证处理 （3）
    mechanStartCheck() {
      if (this.startDate2) {
        if (this.endDate2) {
          // 比较时间大小处理
          let tempDateStart = new Date(this.startDate2);
          let tempDateEnd = new Date(this.endDate2);
          let tempStampStart = tempDateStart.getTime();
          let tempStampEnd = tempDateEnd.getTime();

          if (tempStampEnd > tempStampStart) {
            return true;
          } else {
            this.$message.error("结束时间应该大于开始时间，请重新选择");
            return false;
          }
        } else {
        }
      } else {
        this.$message.error("请选择开始时间");
        return false;
      }
    },

    // 结束验证处理 （4）
    mechanEndCheck() {
      if (this.endDate2) {
        if (this.startDate2) {
          // 比较时间大小处理

          let tempDateStart = new Date(this.startDate2);
          let tempDateEnd = new Date(this.endDate2);
          let tempStampStart = tempDateStart.getTime();
          let tempStampEnd = tempDateEnd.getTime();

          if (tempStampEnd > tempStampStart) {
            return true;
          } else {
            this.$message.error("结束时间应该大于开始时间，请重新选择");
            return false;
          }
        } else {
        }
      } else {
        this.$message.error("请选择结束时间");
        return false;
      }
    },

    addTrain() {
      if (
        !(
          this.mechanNameCheck() &&
          this.mechanClassCheck() &&
          this.mechanStartCheck() &&
          this.mechanEndCheck()
        )
      ) {
        console.log("培训经历参数验证不通过了");
      } else {
        if (this.status == "add") {
          let data = {
            courseName: this.courseName,
            crcId: this.userid,
            endDate: this.endDate2,
            schoolName: this.schoolName2,
            startDate: this.startDate2
          };
          addTrain(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible3 = false;
            })
            .catch(err => {});
        } else if (this.status == "edit") {
          let data = {
            courseName: this.courseName,
            id: this.id,
            endDate: this.endDate2,
            schoolName: this.schoolName2,
            startDate: this.startDate2
          };
          editTrain(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible3 = false;
            })
            .catch(err => {});
        }
      }
    },
    //编辑获得证书
    editcertificate(status, certificateName, getTime, imgurl, id) {
      if (status == "2") {
        this.status = "edit";
      } else {
        this.status = "add";
      }
      this.dialogVisible4 = true;
      this.certificateName = certificateName;
      this.getTime = getTime;
      this.imageUrl = imgurl;
      this.id = id;
    },

    // 获得证书的相关信息的验证处理
    // 证书名称--验证处理
    checkCertiName() {
      if (this.certificateName) {
        return true;
      } else {
        this.$message.error("请输入证书名称");
        return false;
      }
    },

    // 获得日期--验证处理
    checkCertiDate() {
      if (this.getTime) {
        // 判断日期于当前的日期的差距
        let tempDate = new Date(this.getTime);
        let tempStamp = tempDate.getTime();
        let currentStamp = Date.parse(new Date());
        if (tempStamp > currentStamp) {
          this.$message.error("日期非法，请重新选择");
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("请选择获得日期");
        return false;
      }
    },

    // 时间的格式化处理   此函数暂时无用
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    // 上传证书--验证处理
    checkCertiPic() {
      if (this.imageUrl) {
        // console.log("测试证书图片的格式", this.imageUrl);
        return true;
      } else {
        this.$message.error("请上传证书图片");
        return false;
      }
    },

    // 添加获得证书
    getcertificate() {
      if (
        !(
          this.checkCertiName() &&
          this.checkCertiDate() &&
          this.checkCertiPic()
        )
      ) {
        console.log("证书相关参数没有通过验证");
      } else {
        if (this.status == "add") {
          let data = {
            certificateName: this.certificateName,
            crcId: this.userid,
            getTime: this.getTime,
            imgUrl: this.imageUrl
          };
          getcertificate(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible4 = false;
            })
            .catch(err => {});
        } else {
          let data = {
            certificateName: this.certificateName,
            id: this.id,
            getTime: this.getTime,
            imgUrl: this.imageUrl
          };
          editcertificate(data)
            .then(res => {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.getlist();
              this.dialogVisible4 = false;
            })
            .catch(err => {});
        }
      }
    },

    // 新增项目专业选择
    specialchange() {
      getSpecialty(this.specialtyvalue)
        .then(res => {
          this.specialty2 = res.data.data;
          this.specialityId = "";
          console.log(this.specialty2);
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 编辑个人经历
    editExperiences(
      status,
      projectName,
      smoName,
      phasevalue,
      phaselabel,
      speciality,
      startDate3,
      endDate3,
      managerName,
      managerMobile,
      workDesc,
      id
    ) {
      this.dialogVisible5 = true;
      if (status == "2") {
        this.status = "edit";
      } else {
        this.status = "add";
      }

      this.projectName = projectName;
      this.smoName = smoName;
      this.phase = {
        value: "" + phasevalue + "",
        label: phaselabel
      };

      this.speciality = speciality;
      console.log(this.speciality);
      this.startDate3 = startDate3;
      this.endDate3 = endDate3;
      this.managerName = managerName;
      this.managerMobile = managerMobile;
      this.workDesc = workDesc;
      this.id = id;
    },
    // 新增个人经历
    projectExperiences() {
      if (this.status == "add") {
        let data = {
          crcId: this.userid,
          endDate: this.endDate3, //项目结束时间
          managerMobile: this.managerMobile,
          managerName: this.managerName, //证明人姓名
          phase: this.phase.value, //项目类型id
          phaseDesc: this.phase.label, //项目类型name
          projectName: this.projectName, //项目名称
          workDesc: this.workDesc, //项目秒速
          refuseReason: "string",
          smoName: this.smoName, //公司名称
          specialtyId: this.speciality.specId, //专业名称id
          specialtyName: this.speciality.specName, //专业名称
          startDate: this.startDate3 //项目开始时间
        };
        projectExperiences(data)
          .then(res => {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.getlist();
            this.dialogVisible5 = false;
          })
          .catch(err => {});
      } else {
        let data = {
          crcId: this.userid,
          id: this.id,
          endDate: this.endDate3, //项目结束时间
          managerMobile: this.managerMobile,
          managerName: this.managerName, //证明人姓名
          phase: this.phase.value, //项目类型id
          phaseDesc: this.phase.label, //项目类型name
          projectName: this.projectName, //项目名称
          workDesc: this.workDesc, //项目秒速
          smoName: this.smoName, //公司名称
          specialtyId: this.speciality.specId, //专业名称id
          specialtyName: this.speciality.specName, //专业名称
          startDate: this.startDate3 //项目开始时间
        };
        editExperiences(data)
          .then(res => {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.getlist();
            this.dialogVisible5 = false;
          })
          .catch(err => {});
      }
    },
    returns() {
      let token = Cookies.get("token");
      console.log(token);
      Cookies.remove("token");
      Cookies.remove("userid");
      console.log(Cookies.get("token"));
      Cookies.remove("unionId");
      this.$router.push("/login-person");
      window.location.href = "https://www.gcphr.cn";
    }
  },
  mounted() {
    this.userid = Cookies.get("userid");
    // 获得数据
    this.getlist();
    // 获得学历下拉菜单
    getEdu()
      .then(res => {
        this.edulist = res.data.data;
        console.log(this.edulist);
      })
      .catch(err => {
        console.log(err);
      });
    // 获取专业
    getSpecialty(0)
      .then(res => {
        this.specialtylist = res.data.data;
        console.log(this.specialtylist);
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.person-index {
  background: #f5f5f5;
  padding-bottom: 50px;
}

#header {
  width: 100%;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 21px 0px rgba(202, 202, 202, 0.4);
  line-height: 70px;
}

#header img {
  vertical-align: middle;
}

.icon-btn {
  margin-left: 30px;
  cursor: pointer;
}

.icon-btn img {
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 6px;
}

.logo-name {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular;
  font-weight: bold;
  color: rgba(55, 113, 202, 1);
  margin-left: 12px;
}

.peview-add {
  background: none !important;
  margin-top: 20px !important;
}

.person-index >>> .peview-add li {
  border-top: none !important;
  margin-bottom: 20px;
  /* background: #fff; */
}

.icon-cz {
  margin-left: 20px;
  text-align: center;
  /* margin-top: 45px; */
  cursor: pointer;
}

.msg-list-s {
  margin-bottom: 20px;
}

.edit-person {
  margin-top: -30px;
  color: #666666 !important;
}

.el-button--text {
  color: #666 !important;
}

.person-index .buit-btn {
  width: 70px;
  line-height: 26px;
  /* font-size: 12px; */
  height: 26px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(179, 179, 179, 1);
  border-radius: 13px;
  color: #999999;
}

.peview-item > div {
  display: inline-block;
  margin-right: 30px;
  padding: 16px 19px;
  background: #f7f7f7;
  line-height: 25px;
  margin-bottom: 20px;
}

.forms p {
  margin-bottom: 20px;
}

input {
  width: 220px;
}

.forms >>> .el-input--suffix .el-input__inner {
  width: 220px !important;
}

/* 图片上传 */
.forms >>> .avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 105px;
}

.forms >>> .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.forms >>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.forms >>> .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.xm input {
  margin-left: 10px;
}
.peview-img >>> .avatar-uploader .el-upload {
  margin: 0px;
}
.forms .miaoshu {
  margin-right: 10px;
  margin-left: 10px;
  width: 80px;
  transform: translateY(-120px);
}
.projectState {
  display: inline-block;
  color: #3672bf;
  width: 56px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  margin-left: 20px;
  background: rgba(224, 238, 254, 1);
  border-radius: 2px;
}
.header-role {
  padding: 10px 0px;
  text-align: center;
}
.header-role:hover {
  color: red;
  cursor: pointer;
  background-color: #f5f5f5;
}
.preview-list-must {
  color: #F8715F;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/person/home.vue